import React from 'react';
import { Box } from '@mui/system';

type Props = {
  orientation?: 'horizontal' | 'vertical';
  spacing?: number;
};

const Spacer: React.FC<Props> = ({ orientation = 'vertical', spacing = 1 }) => (
  <Box
    sx={{ [orientation === 'horizontal' ? 'width' : 'height']: spacing * 8 }}
  />
);

export default Spacer;
